// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"0ffb7618","433":"909f6d00","480":"81758859","583":"6e8458cf","612":"1f35aac6","796":"c6853542","818":"5809a6ee","830":"f5ad27e8"}[chunkId] + ".chunk.css";
};